import { configureStore, combineReducers } from "@reduxjs/toolkit";
import toggleSlice from "../features/navbar/toggleSlice";
import popUpSlice from "../features/message/popUpSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import transactionsManageSlice from "../features/transaction/transactionsSlice";
import productsReducer from '../features/product/productListSlice';
import logisticReducer from '../features/logistic/logisticSlice';
import warehouseReducer from '../features/warehouse/warehouseSlice';
import companyReducer from '../features/company/companySlice';
import productTransactionHistoryReducer from '../features/product/productTransactionHistorySlice';
import scanProductReducer from "../features/scanproduct/scanProduct";

const rootReducer = combineReducers({
    toggle: toggleSlice,
    popUpToggle: popUpSlice,
    pagination: paginationSlice,
    transactions: transactionsManageSlice,
    products: productsReducer,
    logistic: logisticReducer,
    warehouse: warehouseReducer,
    company: companyReducer,
    productTransactionHistory: productTransactionHistoryReducer,
          scanProducts: scanProductReducer,

})

const store = configureStore({
    reducer: rootReducer
});

export default store;